var map = {
	"./Person1.png": 77,
	"./Person10.png": 78,
	"./Person13.png": 36,
	"./Person2.png": 79,
	"./Person3.png": 37,
	"./Person4.png": 80,
	"./Person5.png": 38,
	"./Person6.png": 81,
	"./Person7.png": 82,
	"./Person8.png": 39,
	"./Person9.png": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;